// eslint-disable-next-line no-restricted-imports
import { Collapse, Space } from 'antd';
import { SizeType } from 'antd/es/config-provider/SizeContext';
import React, { FC, ReactNode } from 'react';
import styled from 'styled-components';
import { SingleLineEllipsis } from 'components/styles';

const AntPanel = Collapse.Panel;

export const Panel = styled(AntPanel)`
  & .ant-collapse-header {
    display: flex;
    align-items: center;
    padding: 0 var(--layout-04) 0 0;
    background-color: var(--white-100);
  }

  & .ant-collapse-header:hover {
    background: var(--hover-color);
    border-color: var(--hover-color);
  }

  & .ant-collapse-content-box {
    padding: 0;
  }
`;

const StyledStrong = styled.p`
  ${SingleLineEllipsis};
  font-weight: var(--heading-6-weight);
  margin: 0;
  margin-right: var(--spacing-01);
`;

interface PanelHeaderTitleProps {
  icon?: ReactNode;
  title?: string | ReactNode;
  size?: SizeType | number;
  noOfItems?: number | undefined;
  endIcon?: ReactNode;
}

export const PanelHeaderTitle: FC<PanelHeaderTitleProps> = ({
  icon,
  title,
  size = 0,
  noOfItems,
  endIcon,
}) => (
  <Space size={size}>
    {icon}
    <StyledStrong>{title}</StyledStrong>
    {noOfItems ? <StyledStrong>({noOfItems})</StyledStrong> : <></>}
    {endIcon != null && endIcon}
  </Space>
);
